import {
    DomainRecruiterNewDriverStatusEnum as RecruitmentConfirmStatus,
    V1RequestStateStringEnum as RequestStatus,
} from '@/shared/api'

import {
    RECRUITMENT_STATUS_ENUM,
    RECRUITMENT_STATUS_RULES,
    RECRUITMENT_STATUS_RULES_WITHOUT_USER_REQUEST,
} from './constants'

export const getRecruitmentStatus = (
    recruitmentConfirmStatus: RecruitmentConfirmStatus,
    requestStatus?: RequestStatus
): RECRUITMENT_STATUS_ENUM => {
    if (!requestStatus) {
        return RECRUITMENT_STATUS_RULES_WITHOUT_USER_REQUEST[recruitmentConfirmStatus]
    }

    return RECRUITMENT_STATUS_RULES[recruitmentConfirmStatus][requestStatus]
}
